module.exports = __webpack_public_path__ + "static/media/hiw5.a8534380.svg";